<script setup>

import { defineProps } from 'vue';

const props = defineProps({
    inputValue: String,
    setInputValue: Function,
    inputOption: Object,
    inputName: {
        type: String,
        default: 'option',
    },
    inputType: {
        type: String,
        default: 'radio',
    },
});


/**
 * inputName : radio/checkbox用
 * 
 * inputType : radio/checkbox
 * 
 * inputOption
 *  {
 *      title: 'XWS5 富邦人壽新平準終身壽險',
 *      subTitle: '1068302189-00',
 *      list: [
 *          { key: '幣別', value: '新臺幣', },
 *          { key: '要保人', value: '林大富', },
 *          { key: '被保險人', value: '林小邦', },
 *      ],
 *      optionValue: '1068302189-00',
 *      textValue: undefined,
 *  },
 */

const inputChange = (e) => {
    props.setInputValue(e.target.value);
}

const getOptionClass = (option) => {
    if (option.disabled) {
        return 'bg-gray border-gray';
    } else if (option.optionValue === props.inputValue) {
        return 'bg-white border-[#0093C1]';
    } else {
        return 'bg-white border-white';
    }
}

</script>

<template>

    <!-- <div class="list-box box--shadow mb-3 bg-white rounded-md overflow-hidden border"
        :class="(inputOption.optionValue === inputValue) ? 'border-[#0093C1]' : ' border-white'"> -->
    <div class="list-box box--shadow mb-3 rounded-md overflow-hidden border" :class="getOptionClass(inputOption)">

        <label>
            <div class="p-4 flex" :class="{ 'list-box__title--blue': inputOption.list }"
                v-if="inputOption.title || inputOption.subTitle">

                <div class="pr-3">
                    <input class="w-[20px] h-[20px] align-text-bottom" :type="inputType"
                        :value="inputOption.optionValue" @change="inputChange" :name="inputName"
                        :disabled="inputOption.disabled" />
                </div>
                <div>
                    <div class="pb-2" v-if="inputOption.subTitle">
                        <span class="inline-block pr-2 text-sm" v-if="inputOption.subTitle">
                            {{ inputOption.subTitle }}</span>
                    </div>
                    <h4 v-if="inputOption.title" class="font-bold">{{ inputOption.title }}</h4>
                </div>

            </div>

            <div class="px-4 pb-4" v-if="inputOption.list">
                <ul>
                    <li class="w-full flex justify-between pt-4" v-for="(item, i) in inputOption.list">
                        <div>{{ item.key }}</div>
                        <div class="font-bold" v-html="item.value"></div>
                    </li>
                </ul>
            </div>
        </label>
    </div>

</template>

<style scoped>
.list-box__title--blue {
    background: linear-gradient(81.29deg, #F0F9FF 2.99%, #E9FFFE 107.35%);
}

.box--shadow {
    box-shadow: 0px 4px 16px 0px #0C0E1F0F;
}
</style>
